import { TypographySmall } from '@talentmesh/ui/components/typography';

interface HeaderProps {
    header: string;
}

function Header({ header }: HeaderProps) {
    return <TypographySmall className="uppercase">{header}</TypographySmall>;
}

export default Header;
